import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { NavigatorStore } from '../stores';
import { Helper } from '../../../Helper';
import { IAPanel } from '../../panels/Panel';
import { AIAssistant } from '../../aiAssistant/AIAssistant';
import { LocalizationService } from '../../../services/LocalizationService';

export interface IProps {
  navigatorStore?: NavigatorStore;
  isShowing?: boolean;
}

export interface IState {
}

@inject('navigatorStore')
@observer
export default class AiAssistantPanel extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  public componentDidMount(): void {
  }

  public render() {
    let top = 0;
    if ((Helper.getDisplayEnvironment() === "Sharepoint" || Helper.getDisplayEnvironment() === "SharepointClassic") && document.getElementById("IA_navigator_bar") != undefined && document.getElementById("IA_navigator_vertical_menu") == undefined) {
      top = 48;
    }
    return (
      <IAPanel
        close={() => this.props.navigatorStore.selectedAiAssistent = undefined}
        open={!!this.props.navigatorStore.selectedAiAssistent}
        showNavigationBar={false}
        transition="slide"
        width={this.props.navigatorStore.isMobile ? window.innerWidth : 600}
        marginTop={top}
        backgroundColor="#ffffff"
      >
        {this.props.navigatorStore.selectedAiAssistent?.aiSites?.length > 0 &&
          <div
            style={{
              padding: "20px 40px"
            }}
          >
            <AIAssistant
              environment={this.props.navigatorStore.environment}
              tenant={this.props.navigatorStore.tenant}
              highlightColor={this.props.navigatorStore.highlightColor}
              contentLanguage={this.props.navigatorStore.selectedAiAssistent.aiContentLanguage ?? "en"}
              sites={this.props.navigatorStore.selectedAiAssistent.aiSites}
              title={this.props.navigatorStore.selectedAiAssistent.aiCustomTitle}
              infoIconUrl={this.props.navigatorStore.selectedAiAssistent.aiCustomIconUrl ?? "https://intraactivestorage.blob.core.windows.net/cdn/icons/Info/SVG/ic_fluent_info_28_regular.svg"}
              infoHeadline={this.props.navigatorStore.selectedAiAssistent.aiCustomHeadline ?? new LocalizationService().strings.AIAssistant_information}
              infoText={this.props.navigatorStore.selectedAiAssistent.aiCustomDescription}
              example={this.props.navigatorStore.selectedAiAssistent.aiCustomExample}
              fontSlots={this.props.navigatorStore.fontSlots}
              onClose={() => this.props.navigatorStore.selectedAiAssistent = undefined}
            />
          </div>
        }
      </IAPanel>
    );
  }
}